import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'eq-seperator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './seperator.component.html',
  styleUrl: './seperator.component.scss',
})
export class SeperatorComponent {}
